import type { Icon } from '../../../src/lib/types'
export const mdiBookVariantMultiple: Icon = {
  "id": "book-variant-multiple",
  "name": "Book Variant Multiple",
  "path": "M4,6H2V20A2,2 0 0,0 4,22H18V20H4V6M20,2H8A2,2 0 0,0 6,4V16A2,2 0 0,0 8,18H20A2,2 0 0,0 22,16V4A2,2 0 0,0 20,2M20,12L17.5,10.5L15,12V4H20V12Z",
  "as": [
    "books-variant"
  ],
  "tags": []
}
export default mdiBookVariantMultiple